import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { LinkContainer } from 'react-router-bootstrap';
import { connect } from 'react-redux';

import { AppointmentScreen, ReviewScreen } from '../screens';
import store from '../helpers/store'

function App({rootPath}) {
  return (
    <Router>
      {/* A <Switch> looks through its children <Route>s and
          renders the first one that matches the current URL. */}
      <Switch>
        <Route path={`/${rootPath}/review`}>
          <ReviewScreen rootPath={rootPath}/>
        </Route>
        <Route path={`/${rootPath}/`}>
          <AppointmentScreen rootPath={rootPath}/>
        </Route>
      </Switch>

    </Router>
  );
}

const mapState = state => ({
});

export default connect(
  mapState,
)(App);
